import h from 'virtual-dom/h'
import * as Actions from '../actions/actions'
import * as CaptureTools from '../utilities/capture-tools'

export default class Renderer {
    constructor(settings, mutators, childRenderers) {
        this._settings = settings;
        this._mutators = mutators;
        this._childRenderers = childRenderers;
    }

    initialize(store) {
        this._store = store;
    }

    doesRender(message) {
        return message.type === this._settings.ResponseActions.displayFeedbackPanes.paneTypes.yesno;
    }

    getRender() {
        return (message) => {
            if(!this.doesRender(message)) return;

            let parameters = {
                className : this._settings.classNames.yesNoFeedbackPane
            };

            this._mutators.forEach((mutate) => {
                parameters = mutate(parameters);
            });

            let childNodes = [];

            this._childRenderers.forEach((render) => {
                childNodes.push(render(message));
            });

            let {header,
                prompt,
                paneId,
                active,
                metadata} = message;

            let attributes = {};
            attributes['data-id'] = paneId;
            attributes['data-active'] = active;

            parameters['attributes'] = attributes;

            let headerNode = this.buildHeader(header);
            let bodyNodes = this.buildBody(prompt, metadata, paneId);
            
            childNodes = childNodes.concat(headerNode, bodyNodes);

            return h('div', parameters, childNodes);
        }
    }

    buildHeader(headerText) {
        let parameters = {
            className: this._settings.classNames.feedbackHeader
        };

        return h('div', parameters, headerText);
    }

    buildBody(promptText, metadata, paneId) {

        let feedbackPanesLocation = this._settings.stateLocations.History.feedbackPanes;
        let activeLocation = this._settings.stateLocations.History.displayFeedback;
        let captureLocation = this._settings.stateLocations.History.capturedFeedback;
        let capturedStageLocation = this._settings.stateLocations.History.capturedStageLocation;

        let promptElement = h('div', {
            className : this._settings.classNames.feedbackPrompt
        }, promptText);

        let buttonElement = h('div', {
            className : this._settings.classNames.yesNoFeedbackButtonArea
        }, [
            h('button', {
                className : this._settings.classNames.noFeedbackButton,
                onclick : () => {
                    CaptureTools.updateFeedback(this._store, captureLocation, paneId, {
                         category : this._settings.Analytics.Feedback.category,
                         action : this._settings.Analytics.Feedback.actions.completePane,
                         label : this._settings.Analytics.Feedback.labels.noButton,
                         value : paneId
                    });
                    if(metadata.no.nextPane === this._settings.ResponseActions.displayFeedbackPanes.nextPaneEndKey) {
                        CaptureTools.endFeedback(this._store, captureLocation, capturedStageLocation, paneId, {
                            category : this._settings.Analytics.Feedback.category,
                            action : this._settings.Analytics.Feedback.actions.completeFeedback
                        });
                        this._store.dispatch(Actions.endDisplayFeedbackPanes(feedbackPanesLocation, activeLocation));
                    } else {
                        this._store.dispatch(Actions.setActiveFeedbackPane(metadata.no.nextPane, feedbackPanesLocation))
                    }
                }
            }, metadata.no.buttonText),
            h('button', {
                className : this._settings.classNames.yesFeedbackButton,
                onclick : () => {
                    CaptureTools.updateFeedback(this._store, captureLocation, paneId, {
                         category : this._settings.Analytics.Feedback.category,
                         action : this._settings.Analytics.Feedback.actions.completePane,
                         label : this._settings.Analytics.Feedback.labels.yesButton,
                         value : paneId
                    });
                    if(metadata.yes.nextPane === this._settings.ResponseActions.displayFeedbackPanes.nextPaneEndKey) {
                        CaptureTools.endFeedback(this._store, captureLocation, capturedStageLocation, paneId, {
                            category : this._settings.Analytics.Feedback.category,
                            action : this._settings.Analytics.Feedback.actions.completeFeedback
                        });
                        this._store.dispatch(Actions.endDisplayFeedbackPanes(feedbackPanesLocation));
                    } else {
                        this._store.dispatch(Actions.setActiveFeedbackPane(metadata.yes.nextPane, feedbackPanesLocation))
                    }
                }
            }, metadata.yes.buttonText)
        ]);

        return h('div', {
            className : this._settings.classNames.feedbackBody
        }, [
            promptElement,
            buttonElement
        ]);
    }
}




// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/window-feedback-overlay/src/renderers/yesnoPane.js